import { useStakeInputErrorMessage } from '@/feature/betslip-sbk/components/bet-inputs/hooks/use-stake-input-error-message';

import { WarningBanner } from './WarningBanner';

export const SingleBetErrorWarning = ({ betId }: { betId: string }) => {
    const errorMessage = useStakeInputErrorMessage(betId);

    if (!errorMessage) {
        return null;
    }

    return <WarningBanner message={errorMessage} />;
};
